// extracted by mini-css-extract-plugin
export default {"h":"styles_h__dfezH","p":"styles_p__dMeQ9","box":"styles_box__fGDfQ"};